import { createContext } from "react";
import { Route, Routes } from "react-router-dom";
import { VipGameCommission } from "../../modules/vipGameCommission/components/VipGameCommission";

const VipGameCommissionContext = createContext();

const VipGameCommissionWrapper = () => {
  const value = {};

  return (
    <VipGameCommissionContext.Provider value={value}>
      <Routes>
        <Route path="" element={<VipGameCommission />} />
      </Routes>
    </VipGameCommissionContext.Provider>
  );
};

export { VipGameCommissionWrapper };
